import { Controller } from "@hotwired/stimulus";
import TomSelect from "tom-select";
// Base styles: node_modules/tom-select/dist/css/tom-select.default.css (Propshaft assets path)

export default class extends Controller {
  connect() {
    this.select = new TomSelect(this.element, {
      plugins: { remove_button: { title: "Remove" } },
      persist: false,
      createOnBlur: true,
      placeholder: "Select or enter tag ...",
      create: (input) => {
        const slug = input
          .replace(/\W/g, "_")
          .split(" ")
          .join("_")
          .toLowerCase();
        return { value: slug, text: slug };
      },
    });
  }

  disconnect() {
    this.select?.destroy();
  }
}
